var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRobotsIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 417 417",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M292.638,120.585c-22.498,-22.496 -52.423,-34.903 -84.242,-34.903c-31.819,0 -61.746,12.407 -84.315,34.834l-9.882,-9.884c25.161,-25.089 58.593,-38.966 94.197,-38.966c35.602,-0 69.034,13.877 94.126,39.037l-9.884,9.882Zm-35.883,91.252c10.162,0 19.133,3.926 26.841,11.634c29.859,29.998 29.928,111.086 29.788,114.522l0,7.008l-210.118,-0l0,-7.008c0,-3.436 0.071,-84.524 29.928,-114.522c7.708,-7.708 16.75,-11.634 26.841,-11.634l96.72,0Zm-72.399,54.457c-13.106,13.178 -17.102,46.538 -17.873,64.69l83.824,0c-0.7,-18.152 -4.696,-51.512 -17.803,-64.69c-3.643,-3.644 -7.568,-5.396 -12.193,-5.396l-23.829,0c-4.557,0 -8.553,1.752 -12.126,5.396m58.101,-9.881c17.873,18.01 21.235,58.24 21.866,74.571l35.045,0c-0.703,-19.836 -4.486,-76.323 -25.724,-97.63c-5.046,-5.045 -10.512,-7.5 -16.889,-7.5l-96.72,0c-6.306,0 -11.844,2.455 -16.889,7.5c-21.236,21.307 -25.021,77.794 -25.721,97.63l35.041,0c0.632,-16.331 3.997,-56.561 21.867,-74.571c6.309,-6.309 13.738,-9.531 22.149,-9.531l23.829,-0c8.41,-0 15.837,3.222 22.146,9.531m30.348,-115.993c-17.171,-17.241 -40.09,-26.702 -64.409,-26.702c-24.318,0 -47.238,9.461 -64.408,26.702l9.881,9.882c14.577,-14.577 33.92,-22.567 54.527,-22.567c20.604,0 39.948,7.99 54.525,22.567l9.884,-9.882Zm-89.219,39.599l-9.884,-9.882c9.181,-9.223 21.681,-14.4 34.694,-14.369c13.104,0 25.44,5.117 34.692,14.369l-9.881,9.882c-6.659,-6.588 -15.419,-10.234 -24.811,-10.234c-9.392,-0 -18.152,3.646 -24.81,10.234"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRobotsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Robots_Icon.aa11044b434c6e4923d2929c1e57b5d6.svg";